import { Box, BoxProps, styled } from "@mui/system";

export const Section = styled(Box)<BoxProps>(() => ({
  minHeight: "calc(80vh - 10rem)",
  padding: "1rem 0",
  display: "flex",
  flexDirection: "column",
}))